import React from 'react';
import { LinkToCommonLogin } from '../../components/index';
import { UnifiedLayout } from '../../layouts/UnifiedLayout/UnifiedLayout';
import { Divider, Header } from '@solarwindscloud/nighthawk-ui';

export const dataTestIds = {
  noMatch: 'no-match',
  linkToLogin: 'link-to-common-login',
};
const NoMatch = () => (
  <UnifiedLayout headerText="Not Found - 404" dataTestId={dataTestIds.noMatch} dataTestPageName="NoMatch">
    <Header textAlign="center">
      <Header.Subheader>
        Sorry, We could not find the page you were looking for.
        <Divider hidden />
        <LinkToCommonLogin>Continue to Login</LinkToCommonLogin>
      </Header.Subheader>
    </Header>
  </UnifiedLayout>
);

export default NoMatch;
